interface BoxAndAdjustableWrenchSVGProps {
  color: string;
  style: React.CSSProperties;
}

const BoxAndAdjustableWrenchSVG = ({
  color,
  style,
}: BoxAndAdjustableWrenchSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="53"
    height="56"
    viewBox="0 0 53 56"
    fill="none"
  >
    <g clipPath="url(#clip0_564_17778)">
      <path
        d="M27.1956 53.2291C28.1742 52.4611 28.7923 51.3506 28.9468 50.1053C29.0498 49.2024 29.5546 48.4136 30.3169 47.9466L34.2828 45.5078L41.195 41.2632C42.4827 40.4744 44.0381 40.1838 45.5009 40.5263C45.9542 40.6301 46.428 40.6716 46.8916 40.6301C48.1277 40.5263 49.2506 39.9452 50.0541 38.98C51.7023 36.9978 52.1658 35.3788 52.4337 33.1994C52.4646 32.9815 52.1967 32.8466 52.0422 33.0022L48.8591 36.0949C48.3029 36.6345 47.4994 36.8317 46.7577 36.6034L46.5414 36.5411C45.4288 36.1987 44.5635 35.3165 44.2442 34.1957L44.1515 33.874C43.9351 33.106 44.1515 32.2758 44.718 31.7257L47.8702 28.6642C48.0247 28.5085 47.9114 28.2491 47.6848 28.2595C45.5112 28.4463 43.8939 28.8614 41.8646 30.4492C40.886 31.2172 40.2679 32.3277 40.1134 33.573C40.0103 34.4759 39.5056 35.2646 38.7433 35.7317L34.7773 38.1705L27.8652 42.4151C26.5775 43.2039 25.022 43.4944 23.5592 43.152C23.106 43.0482 22.6321 43.0067 22.1686 43.0482C20.9324 43.152 19.8096 43.7331 19.0061 44.6983C17.3579 46.6805 16.8943 48.2995 16.6265 50.4789C16.5956 50.6968 16.8634 50.8317 17.0179 50.6761L20.201 47.5834C20.304 47.4796 20.4173 47.3966 20.541 47.3239C20.5822 47.3032 20.6234 47.2721 20.6646 47.2513C21.159 46.9815 21.7565 46.9088 22.3128 47.0853L22.5291 47.1475C23.6416 47.49 24.5069 48.3721 24.8263 49.493L24.919 49.8147C25.0323 50.1987 25.0323 50.593 24.9293 50.9667C24.8263 51.3403 24.6306 51.6827 24.3524 51.9629L21.2002 55.0245C21.0457 55.1801 21.159 55.4396 21.3857 55.4292C23.5592 55.2424 25.1765 54.8273 27.2059 53.2394L27.1956 53.2291Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.2665 14.4981L27.7925 22.344"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.6228 22.3232L7.17969 14.4982L11.6401 11.9348"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.5103 41.5122L7.17969 34.3306V22.344"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.2666 22.3232V28.2595"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.2285 28.685V37.5893"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.2285 24.4196L30.8213 28.2595L47.8699 18.338L41.2668 14.4982L36.7342 11.8517"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.17977 14.4981L0.57666 18.338L17.6253 28.2594L24.2284 24.4196"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.3715 17.5285C11.8977 16.1898 11.6401 14.7576 11.6401 13.2528C11.6401 6.25797 17.2749 0.581177 24.2283 0.581177C31.1816 0.581177 36.8061 6.25797 36.8061 13.2528C36.8061 14.7472 36.5486 16.1898 36.0747 17.5285"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.2879 13.2528C27.2879 14.9548 25.9178 16.3351 24.2284 16.3351C22.539 16.3351 21.1689 14.9548 21.1689 13.2528C21.1689 11.5508 22.539 10.1705 24.2284 10.1705C25.9178 10.1705 27.2879 11.5508 27.2879 13.2528Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.2282 19.9155C27.8806 19.9155 30.8416 16.9325 30.8416 13.2528C30.8416 9.57306 27.8806 6.59006 24.2282 6.59006C20.5757 6.59006 17.6147 9.57306 17.6147 13.2528C17.6147 16.9325 20.5757 19.9155 24.2282 19.9155Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.5703 7.15049L19.2319 1.61899"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.814 7.15049L29.1421 1.61899"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_564_17778">
        <rect width="53" height="56" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default BoxAndAdjustableWrenchSVG;
